import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="container not-found">
      <p className="not-found-code">404</p>
      <p className="not-found-msg">this page doesn't exist.<br />you might be lost.</p>
      <Link to="/" className="back-link">← back home</Link>
    </div>
  );
}
